(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('DetailAppointmentTypeController', [
        '$uibModalInstance', 
        '$scope',
        'Alert', 
        'AppointmentTypeService', 
        'ContactInfoService',
        'SharedAgendaService',
        'GroupPracticeService',
        'HelperService', 
        'ItemTableService', 
        'type', 
        'colors', 
        'languages', 
        'agendalabels', 
        DetailAppointmentTypeControllerFn]);

    /* controlle for appointment type modal */
    function DetailAppointmentTypeControllerFn(        
        $uibModalInstance, 
        $scope,
        Alert, 
        AppointmentTypeService,
        ContactInfoService,
        SharedAgendaService,
        GroupPracticeService, 
        HelperService, 
        ItemTableService, 
        type, 
        colors, 
        languages, 
        agendalabels) {

        var vm = this;
        
        vm.selectedAgendaLabels = [];
        // current type 
        vm.type = {};
        // list of possible colors
        vm.colors = [];
        // list of possible languages
        vm.languages = [];
        // list of agenda labels
        vm.agendalabels = [];
        // list of possible durations (from agenda interval or saved custom input)
        vm.durationintervals = [];
        vm.locations = [];
        // current translation from table
        vm.table = {};

        activate();

        $scope.$watch('vm.type.isVideoConsultType', function(newVal, oldVal) {
            if(vm.type.isVideoConsultType)
            {
                vm.type.askConfirmationWhileSaving = true;
            }
        });
        // abort
        vm.abort = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // save current item 
        vm.save = function () {
            syncSelectedAgendaLabelsToType();
            vm.type.translations = ItemTableService.list();
            // prepare for backend 
            vm.type.prepareForSave();

            // save or update
            if (vm.type.id > 0) {
                // update
                return AppointmentTypeService.update(vm.type.id, vm.type).then(function (result) {
                    // close modal
                    $uibModalInstance.close(result);
                    Alert.success("appointment type updated successfully");
				}, function (error) {
					// reload modal view
					$uibModalInstance.dismiss('reload');
				});
            } // if
            else {
                // save
                return AppointmentTypeService.save(vm.type).then(function (result) {
                    // close modal
                    $uibModalInstance.close(result);
                    Alert.success("appointment type saved successfully");
				}, function (error) {
					// reload modal view
					$uibModalInstance.dismiss('reload');
				});
            } // else
        };
        
        vm.addEmail = function()
        {
            let contactInfoType = ContactInfoService.createContactInfoByTypeValue(3);
            contactInfoType.id = vm.type.emails.length + 1;
            vm.type.emails.push(contactInfoType);
            
        }

        vm.addMobile = function()
        {
            let contactInfoType = ContactInfoService.createContactInfoByTypeValue(2);
            contactInfoType.id = vm.type.mobileNumbers.length + 1;
            vm.type.mobileNumbers.push(contactInfoType);
        }

        vm.selectLocation = function(location) {  
            if (!location.id) {
                vm.type.internalLocation = null;
                vm.type.fK_InternalLocation = null;    
                return;
            }

            vm.type.internalLocation = location;
            vm.type.fK_InternalLocation = location.id;
        };


        // activate
        function activate() {
            vm.type = type;
            vm.colors = colors;
            vm.languages = languages;
            vm.agendalabels = agendalabels;

            // list of duration intervals
            vm.durationintervals = HelperService.generateDurationIntervals();

            // set default color if not selected yet
            if (vm.type.fK_Color === null && vm.colors.length > 0) {
                vm.type.fK_Color = vm.colors[0].id; // default first color
            } //if

            initializeSelectedAgendaLabels();

            // table with translations
            vm.table = ItemTableService.data;
            
            loadInternalLocations();

            // clear
            type = null;
            colors = null;
            languages = null;
            agendalabels = null;
        }

        function initializeSelectedAgendaLabels() {
            let selectedAgendaLabels = [];

            if (vm.type.agendaLabelAppointmentTypes) {
                selectedAgendaLabels = vm.type.agendaLabelAppointmentTypes
                  .filter(aa => aa && !aa.deleted)
                  .map(aa => aa.fK_AgendaLabel);
            }

            if (vm.type.fK_AgendaLabel) {
                selectedAgendaLabels.push(vm.type.fK_AgendaLabel);
            }
            
            vm.selectedAgendaLabels = selectedAgendaLabels
              .filter(onlyUnique)
              .map(labelId => vm.agendalabels.find(label => label.id === labelId));

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
        }

        function syncSelectedAgendaLabelsToType() {
            for (const result of vm.type.agendaLabelAppointmentTypes) {
                let foundAa = vm.selectedAgendaLabels.find(label => label.id === result.fK_AgendaLabel);
                result.deleted = !foundAa;
            }

            for (const selected of vm.selectedAgendaLabels) {
                let foundAa = vm.type.agendaLabelAppointmentTypes.find(label => label.fK_AgendaLabel === selected.id);
                if (foundAa) {
                    // Re-enable if it was deleted
                    foundAa.deleted = false;
                } else {
                    // Create new entry only if it doesn't exist
                    vm.type.agendaLabelAppointmentTypes.push({
                        fK_AgendaLabel: selected.id,
                        fK_AppointmentType: vm.type.id,
                        deleted: false
                    });
                }
            }
            
            if (vm.type.agendaLabelAppointmentTypes.length > 0) {
                let foundAa = vm.type.agendaLabelAppointmentTypes.find(label => label.fK_AgendaLabel === vm.type.fK_AgendaLabel && !label.deleted); 
                if (!foundAa) {
                    let firstNonDeleted = vm.type.agendaLabelAppointmentTypes.find(label => !label.deleted);
                    vm.type.fK_AgendaLabel = firstNonDeleted ? firstNonDeleted.fK_AgendaLabel : null;
                }
            } else {
                vm.type.fK_AgendaLabel = null;
            }
        }

        function loadInternalLocations() {
            var groupPracticeId = SharedAgendaService.currentUser().groupPracticeId;
            GroupPracticeService.getInternalLocations(groupPracticeId)
                .then(function(locations) {
                    locations.unshift({
                        id: null,
                        name: ' - '
                    });

                    vm.locations = locations;                    
                });
        }
    }
})();
